// extracted by mini-css-extract-plugin
module.exports = {"item":"OfferList_item_d6Qx1"};